<template>
    <div class="col-md-6">
        <label class="attribute-label m-bottom-12">Minimum Charge</label>
        <label class="figma-switch float-right-mobile">
            <input :id="`checkbox_${id}`" :checked = "minumumChargeValue" :name="`checkbox_${name}`" type="checkbox" @click="updateMinimumCharge">
            <span @for="`checkbox_${id}`" class="slider round"> </span>
        </label>
        <input type="hidden" name="consider_booking_min_price" id="consider_booking_min_price" :value="minumumChargeValue">

        <div class="input-group width-100">
            <input type="text" class="form-control price-new-inputs"  :id="id" :name="name" :value="minimumCharge.toFixed(2)" disabled readonly>

            <span class="input-group-addon input-group-addon-new-design" style="background-color: #F5F5F6 !important;">
                <b> {{ currency.currency_symbol }} </b>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "BookingMinimumCharge",
    props: ['value', 'minimumCharge', 'currency'],
    data() {
        return {
            minumumChargeValue: this.value
        }
    },
    computed: {
        id() {
            return 'booking_min_price'
        },
        name() {
            return 'booking_min_price'
        }
    },
    methods: {
        updateMinimumCharge() {
            this.minumumChargeValue = !this.minumumChargeValue
            // let value = this.minumumChargeValue ? 1 : 0 ;
            this.$emit('input',this.minumumChargeValue)
        }
    }
}
</script>

<style scoped>

</style>